module.exports = __webpack_public_path__ + "img/logo-wompi.ba902011.png";